<template>
  <el-row class="cs-contentContainer">
    <el-col :span="4" class="cs-contentContainer-registerLeft">
      <div>&nbsp;</div>
    </el-col>
    <el-col :span="16" class="cs-fullHeight cs-contentContainer-registerMiddle">
      <div class="cs-fullHeight-content">
        <el-form :model="registerForm" :rules="rules" label-width="100px" ref="registerForm">
          <div>
            <el-row class="margin-bottom-2px backgroud-white cs-register-title">
              <el-col :span="24" class="su-title">
                <span>速成学员注册</span>
              </el-col>
            </el-row>
            <el-row class="backgroud-white cs-register-main">
              <el-col :span="6">
                &nbsp;
              </el-col>
              <el-col :span="12">
                <div class="grid-content">
                  <el-form-item prop="phoneType" label="手机号码">
                    <el-select @change='checkAllInputs' v-model="registerForm.phoneType" placeholder="请选择">
                      <el-option v-for="item in phoneTypeList" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item prop="phone" label="" class="su-phone">
                    <el-input placeholder="请输入手机号码" @change='checkAllInputs' v-model="registerForm.phone" maxlength="11"></el-input>
                  </el-form-item>
                  <el-form-item class="su-left-align cs-register-code">
                    <el-button :disabled="smsBtnDisable" v-bind:type="smsBtnClass" @click="smsBtnClick" class="smsBtn">{{smsBtnText}}</el-button>
                    <span>收不到验证码</span>
                    <el-tooltip class="item" effect="dark" placement="top">
                      <div slot="content">请确认输入的手机号码为10位数<br/>北美手机号或11位数中国手机号，<br/>若还是无法收到验证码，请联系客服</div>
                      <img src="../assets/question.png">
                    </el-tooltip>
                  </el-form-item>
                  <el-form-item prop="code" label="验证码">
                    <el-input @change='checkAllInputs' placeholder="请输入收到的验证码" v-model="registerForm.code"></el-input>
                  </el-form-item>
                  <el-form-item prop="lastName" label="姓">
                    <el-input @change='checkAllInputs' placeholder="请输入驾照，护照，学生证上合法的Legal Name" v-model="registerForm.lastName"></el-input>
                  </el-form-item>
                  <el-form-item prop="firstName" label="名">
                    <el-input @change='checkAllInputs' placeholder="请输入驾照，护照，学生证上合法的Legal Name" v-model="registerForm.firstName"></el-input>
                  </el-form-item>
                  <el-form-item prop="email" label="邮箱">
                    <el-input @change='checkAllInputs' placeholder="请输入邮箱" v-model="registerForm.email"></el-input>
                  </el-form-item>
                  <el-form-item prop="universityId" label="学校">
                    <el-select @change='checkAllInputs' v-model="registerForm.universityId" placeholder="请选择">
                      <el-option v-for="item in universityList" :key="item.Key" :label="item.Value" :value="item.Key">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item prop="password" label="密码">
                    <el-input @change='checkAllInputs' placeholder="请输入登录密码" type="password" v-model="registerForm.password">
                    </el-input>
                  </el-form-item>
                  <el-form-item prop="confirmPassword" label="重复密码">
                    <el-input @change='checkAllInputs' placeholder="请再次输入登录密码" type="password" v-model="registerForm.confirmPassword">
                    </el-input>
                  </el-form-item>
                  <el-form-item class="su-left-align cs-register-btn-container">
                    <!-- 暂时去掉<small>我已阅读并同意<span class="su-blue su-service-label" @click="showServiceDialog">速成服务条款</span></small>   
                    <el-checkbox v-model="registerForm.checkedService"></el-checkbox>-->
                    <div class="errorMessageContainer">
                      <el-alert class="cs-register-alert" :closable="false" v-if="showError" v-bind:title="errorMessage" type="error" show-icon></el-alert>
                    </div>
                    <div class="cs-register-btn">
                      <el-button :disabled="registerBtnDisable" v-bind:type="registerBtnClass" @click="registerUser">立即注册</el-button>
                    </div>
                  </el-form-item>
                  <!-- <el-form-item class="errorMessageContainer">
                    <el-alert :closable="false" v-if="showError" v-bind:title="errorMessage" type="error" show-icon></el-alert>
                  </el-form-item> -->
                </div>
              </el-col>
              <el-col :span="6">
                &nbsp;
              </el-col>
            </el-row>
            <el-row class="cs-register-mobile backgroud-white">
              <el-col>
                 <el-button :disabled="registerBtnDisable" v-bind:type="registerBtnClass" @click="registerUser">立即注册</el-button>
                  <div class="errorMessageContainer">
                    <el-alert class="cs-register-alert" :closable="false" v-if="showError" v-bind:title="errorMessage" type="error" show-icon></el-alert>
                  </div>
              </el-col>
            </el-row>
            <el-row class="backgroud-gray su-left-align cs-register-foot">
              <el-col :span="6">
                <div class="el-form-control">
                  &nbsp;
                </div>
              </el-col>
              <el-col :span="18">
                <div class="el-form-control">
                  <strong> &nbsp;</strong>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="el-form-control">
                  &nbsp;
                </div>
              </el-col>
              <el-col :span="18">
                <div class="el-form-control cs-bold">
                  <small>速成教育会员注册</small>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="el-form-control">
                  &nbsp;
                </div>
              </el-col>
              <el-col :span="18">
                <div class="el-form-control">
                  <small>凡是在速成教育报名的学员，必须注册速成学员账号，并按时提交在校课程时间表</small>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="el-form-control">
                  &nbsp;
                </div>
              </el-col>
              <el-col :span="18">
                <div class="el-form-control">
                  <strong> &nbsp;</strong>
                </div>
              </el-col>
            </el-row>
            <el-row class="hidden-xs-only cs-register-bottom backgroud-black text-center">
              <el-col>
                <footer>
                  <small>Powered by Speed Up Education Inc.</small>
                </footer>
              </el-col>
            </el-row>
          </div>
          <el-dialog :close-on-click-modal="false" title="速成服务条款" :center="true" :visible.sync="dialogVisible" width="50%">
            <span>服务条款：</span>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="dialogVisible = false">关闭</el-button>
            </span>
          </el-dialog>
        </el-form>
      </div>
    </el-col>
    <el-col :span="4" class="cs-contentContainer-registerRight">
      <div>&nbsp;</div>
    </el-col>
  </el-row>
</template>

<style lang="scss" scoped>
.registerForm {
  text-align: left;
}
.grid-content {
  margin-top: 26px;
  .su-phone {
    margin-bottom: 15px;
  }
}
.su-title {
  font-size: 20px;
  font-weight: bold;
  margin-top: 35px;
  text-align: center;
}
.su-service-label {
  font-weight: bold;
  cursor: pointer;
}
.el-form-item {
  margin-bottom: 10px;

  &.is-required {
    label {
      &:before {
        content: "";
      }
    }
  }
}
.smsBtn {
  width: 150px;
}
.cs-register-foot {
  padding: 5px 0 5px 0;
  .el-form-control {
    margin-bottom: 0px;
  }
}
.cs-register-btn-container {
  margin-top: 10px;
  margin-bottom: 10px;
  text-align: left;

  .cs-register-btn {
    display: inline-block;
    vertical-align: middle;
    float: right;
  }
}

.errorMessageContainer {
  display: inline-block;
  vertical-align: middle;
  min-height: 56px;

  .cs-register-alert {
    padding: 0 10px;
  }
}

.cs-register-bottom{
  height:60px;
  footer{
    line-height: 60px;
  }
}

</style>

<script>
import { getPhoneTypeList } from "../service/api-base.service";
import { userRegister } from "../service/user.service";
import { getAllUniversities, sendSMS } from "../service/common.service";
import { setStore, saveUserInStore } from "../config/mUtils";
export default {
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.registerForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      let isValid = value.match(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/
      );
      if (!isValid) {
        callback(new Error("密码需为8位长度的大小写字母和数字"));
      } else {
        callback();
      }
    };
    var validatePhone = (rule, value, callback) => {
      let message = "";
      if (!value) {
        message = "请输入手机号码";
      } else {
        if (this.registerForm.phoneType == 1) {
          if (value.length != 10) {
            message = "请输入10位数北美手机号";
          }
        } else {
          if (value.length != 11) {
            message = "请输入11位数中国手机号";
          }
        }
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };
    getAllUniversities().then(result => {
      if (!!result && result.success) {
        this.universityList = result.data;
      }
    });
    return {
      universityList: [],
      showError: false,
      errorMessage: "",
      dialogVisible: false,
      registerBtnClass: "info",
      registerBtnDisable: true,
      smsBtnDisable: true,
      smsBtnClass: "info",
      smsBtnText: " 发送验证码 ",
      isSendSMS: false,
      timer: null,
      phoneTypeList: [],
      registerForm: {
        phoneType: 1,
        phone: "",
        code: "",
        firstName: "",
        lastName: "",
        email: "",
        universityId: "",
        password: "",
        confirmPassword: "",
        checkedService: false
      },
      rules: {
        phoneType: [
          {
            required: true,
            message: "请选择号码归属地",
            trigger: "blur"
          }
        ],
        phone: [
          // {
          //   required: true,
          //   message: "请输入手机号码",
          //   trigger: "blur"
          // },
          // {
          //   min: 0,
          //   max: 11,
          //   message: "最大长度在为11个字符",
          //   trigger: "blur"
          // },
          {
            required: true,
            validator: validatePhone,
            trigger: "blur"
          }
        ],
        code: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur"
          }
        ],
        firstName: [
          {
            required: true,
            message: "请输入驾照，护照，学生证上合法的Legal Name",
            trigger: "blur"
          }
        ],
        lastName: [
          {
            required: true,
            message: "请输入驾照，护照，学生证上合法的Legal Name",
            trigger: "blur"
          }
        ],
        email:[
          {
            required: true,
            message: "请输入邮箱",
            trigger: "blur"
          },
          {
            type: 'email',
            message: "邮箱格式错误",
            trigger: "blur"
          }
        ],
        universityId: [
          {
            required: true,
            message: "请选择大学",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            validator: validatePass,
            trigger: "blur"
          }
        ],
        confirmPassword: [
          {
            required: true,
            validator: validatePass2,
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    this.phoneTypeList = getPhoneTypeList();
  },
  beforeDestroy() {
    if (!!this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    //发送登录信息
    async registerUser() {
      this.registerBtnDisable = true;
      this.showError = false;
      this.errorMessage = "";
      if (!!this.$refs["registerForm"]) {
        let isValid = true;
        this.$refs["registerForm"].validate(valid => {
          if (valid) {
          } else {
            isValid = false;
          }
        });
        if (!isValid) {
          return false;
        }
        // if (!this.registerForm.checkedService) {
        //   this.errorMessage = "请先阅读服务条款";
        //   this.showError = true;
        //   return false;
        // }
        let result = await userRegister(
          this.registerForm.phone,
          this.registerForm.code,
          this.registerForm.universityId,
          this.registerForm.firstName,
          this.registerForm.lastName,
          this.registerForm.email,
          this.registerForm.password,
          this.registerForm.confirmPassword
        );
        if (result) {
          if (!result.success) {
            this.errorMessage = result.message;
            this.showError = true;
          } else {
            saveUserInStore(result.data);
            this.$emit("logged-event", true);
            if (result.data.HasStudentCourseNumber) {
              this.$router.push("/studentLanding");
            } else {
              this.$router.push("/studentLanding");
              //this.$router.push("/courseCount");
            }
          }
          this.registerBtnDisable = false;
        }
      }
    },
    setSMSBtnState(isDisable) {
      if (isDisable) {
        this.smsBtnDisable = true;
        this.smsBtnClass = "info";
      } else {
        this.smsBtnDisable = false;
        this.smsBtnClass = "primary";
      }
    },
    afterSMSSend() {
      this.isSendSMS = true;
      this.setSMSBtnState(true);
      let count = 60;
      this.smsBtnText = count.toString() + "秒后重新发送";

      let self = this;
      if (self && !self._isDestroyed) {
        self.timer = setInterval(() => {
          if (self && !self._isDestroyed) {
            count--;
            if (count == 0) {
              this.isSendSMS = false;
              this.setSMSBtnState(false);
              this.smsBtnText = " 发送验证码 ";
              clearInterval(self.timer);
            } else {
              this.smsBtnText = count.toString() + "秒后重新发送";
            }
          }
        }, 1000);
      }
    },
    checkFieldValidate(fieldName) {
      let fieldValid = true;
      this.$refs["registerForm"].validate((valid, elements) => {
        if (fieldName in elements) {
          fieldValid = false;
        }
      });
      return fieldValid;
    },
    async smsBtnClick() {
      if (this.isSendSMS) return;

      if (!this.checkFieldValidate('phone')){
      //if (!this.registerForm.phone) {
        this.$message({
          message: "请先输入有效的电话号码！",
          type: "warning"
        });
        return false;
      }
      this.smsBtnDisable = true;
      await sendSMS(this.registerForm.phone).then(result => {
        if (!!result) {
          if (result.success) {
            this.$message("验证码发送成功，请注意查收！");
            this.afterSMSSend();
          } else {
            if (result.message) {
              this.$message({
                message: result.message,
                type: "error"
              });
            }
          }
        }
      });
    },
    showServiceDialog() {
      this.dialogVisible = true;
    },
    checkAllInputs() {
      if (!this.isSendSMS) {
        if (this.checkFieldValidate('phone')){
        //if (!!this.registerForm.phone) {
          this.setSMSBtnState(false);
        } else {
          this.setSMSBtnState(true);
        }
      }

      if (
        !!this.registerForm.phone &&
        !!this.registerForm.code &&
        !!this.registerForm.firstName &&
        !!this.registerForm.lastName &&
        !!this.registerForm.email &&
        !!this.registerForm.universityId &&
        !!this.registerForm.password &&
        !!this.registerForm.confirmPassword &&
        this.registerForm.password == this.registerForm.confirmPassword
      ) {
        this.registerBtnClass = "primary";
        this.registerBtnDisable = false;
      } else {
        this.registerBtnClass = "info";
        this.registerBtnDisable = true;
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/page/register.vue